import moment from 'moment';
import { DEFAULT_HOUR_MINUTE_DISPLAY } from 'pages/TrackAndTrace/config';
import React from 'react';
import { DATE_DISPLAY_FORMAT } from '../container-config';

interface FormattedDateTimeProps {
  dateTimeString: string;
  timezone: string;
}

export const FormattedDateTime: React.FC<FormattedDateTimeProps> = ({
  dateTimeString,
  timezone,
}) => {
  if (!dateTimeString) return <>-</>;

  const asMomentDate = moment(new Date(dateTimeString)).tz(timezone);
  const date = asMomentDate.format(DATE_DISPLAY_FORMAT);
  const time = asMomentDate.format(`${DEFAULT_HOUR_MINUTE_DISPLAY} z`);
  return (
    <>
      {date} · {time}
    </>
  );
};
FormattedDateTime.displayName = 'ContainerTracking.FormattedDateTime';

interface FormattedDateProps {
  dateString: string;
}

export const FormattedDate: React.FC<FormattedDateProps> = ({ dateString }) => {
  if (!dateString) return <>-</>;

  const asMomentDate = moment(new Date(dateString));
  const date = asMomentDate.format(DATE_DISPLAY_FORMAT);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{date}</>;
};
FormattedDate.displayName = 'ContainerTracking.FormattedDate';
